export const Currencies = 'ETH, BNB and MATIC';

export const SiteType = 'Testnet';

export const SiteName = 'NFTHev';

export const ApprovedFileTypes = '.PNG, .JPG, .GIF';

export const SitePolicyEmail = 'policy@nfthev.io'








